<template>
    <card class="news">
        <span slot="title">
            新闻公告
        </span>

        <el-link 
        slot="title-r"
        :underline="false" 
        type="primary"
        href="/news"
        >
            查看更多>
        </el-link>

        <list
            :data="tableData"
            :props="{title:'title', time:'infodate'}"
            v-loading.sync="loadingController"
            :href="hrefBuilder"
        ></list>
    </card>
</template>

<script>
import CONFIG from '@config/index';

import List from '@components/sys/list';
import Card from '@components/sys/card';

export default {
    components: {
        List,
        Card,
    },
    data() {
        return {
            tableData: [],

            loadingController: false,
        };
    },
    methods: {
        queryData() {
            this.loadingController = true;

            this.$get(`${this.$store.state.api.webUrl}/index/information/getnewsnotice.json`,{
                featurecode:CONFIG.head.planName,
                featureonly:'1'
            }, data => {
                this.tableData = data;

                this.loadingController = false;
            });
        },
        hrefBuilder(item) {
            var search = toSearch({
                infoid: item.infoid,
            });

            return `/news/detail${search}`;
        },
    },
    mounted() {
        this.queryData();
    },
};
</script>

<style lang="scss" scoped>
    @import '@css/var.scss';

    .news{
        height: 275px;
    }
</style>